import './CallsList.css';
import React, { useEffect, useState } from "react";
import { DataTable, DataTableCustomActions, DataTableField } from '../data/DataTable';
import { API_ROUTES } from '../../core/Constants';
import { callRecordingUrl, createJob, getOwner, openJobQuickView, pauseGlobalPlayer, playCall, playGlobalPlayer, shareCalls, toPrettyDate, useGlobal, useHasCallRecording, useHub, useJobs, usePhoneLines } from '../../core/Global';
import Icon from '../base/Icon';
import Avatar from "../base/Avatar";
import FilterProps from "./calls_filtering.json";
import CallQuickView from '../calls/CallQuickView';
import { DataSelect, DataTab } from '../../core/Types';
import { CallSources, CallTypes } from 'src/core/Enums';
import Call, { CallListener } from '../../modules/voice/calls/models/Call';
import { Link } from 'react-router-dom';
import CallAgent from '../../modules/voice/calls/models/CallAgent';
import { CompactJob, CompactUser } from '../../core/CompactModels';
import DropdownMenu, { MenuItem } from '../menu/DropdownMenu';
import { FilterParam } from '../../models/BrowseOptions';
import FlexRow from '../base/FlexRow';

interface IProps {
  agentId?: string
  extId?: string
  jobId?: string
  isChild?: boolean
  compact?: boolean
  showCompany?: string
  keyword?: string
  noHeader?: boolean
  noFilter?: boolean
  noAction?: boolean
  noLabels?: boolean
  agentView?: boolean
  noMultipleAction?: boolean
  onlyIncoming?: boolean
  noPlay?: boolean
  noType?: boolean
  filterParams?: FilterParam[]
  refresh?: boolean
}

function CallsList(props: IProps) {

  const owner = getOwner();
  const [globalState, setGlobalState] = useGlobal();
  const phoneLines = usePhoneLines();
  const [playRecording, playRecordingSet] = useState<string>();
  const [selectedCall, selectedCallSet] = useState<any>();
  const [events, eventsSet] = useState<string[]>();
  const [eventsLoading, eventsLoadingSet] = useState<boolean>();
  const [modalCloseEvent, modalCloseEventSet] = useState<boolean>(false);


  const hub = useHub()
  const jobs = useJobs()
  const hasCallRecording = useHasCallRecording()

  const tabs: DataSelect[] = [
    {
      title: "Queues",
      name: "Queues",
      options: []
    },
    {
      title: "Statuses",
      name: "Status",
      options: [
        {
          name: "Answered",
          value: "ANSWERED"
        },
        {
          name: "No Answer",
          value: "NO ANSWER"
        },
        {
          name: "Busy",
          value: "BUSY"
        },
        {
          name: "Failed",
          value: "FAILED"
        }
      ]
    },
    {
      title: "Types",
      name: "Type",
      options: [
        {
          name: "Incomming",
          value: "1"
        },
        {
          name: "Outgoing",
          value: "2"
        }
      ]
    }
  ];



  const fetchEvents = async (id: string) => {
    eventsLoadingSet(true);
    await hub.Get("/system/calls/events/" + id,
      res => {
        eventsSet(res.data);
        eventsLoadingSet(false);
      }
    )

  }
  // Recordings are only offered to an account whose plan carries them. Nothing has stopped the
  // calls being recorded yet, so a plan without it is simply not shown them -- not the "Not
  // Recorded" icon either, which would say something untrue about the call.
  const RecordingFile = (data: any) => (
    <div className="calls-reports-actions">
      {
        !hasCallRecording ? <></> :
        (data?.recordingFile != null && data.recordingFile != "") ?
          <>
            <a href="#"
              data-bs-toggle="modal"
              data-bs-target="#modalListenToCall"
              onClick={e => {
                e.preventDefault();
                playRecordingSet(data.id);
                selectedCallSet(data);
              }}
              title="Play Recorded Call">
              <Icon icon="volume-high" />
            </a>
          </>
          :
          <a title="Not Recorded">
            <Icon icon="volume-high" color="#ccc" />
          </a>
      }

    </div>
  )

  const TechItem = (p: { tech?: CompactUser, number?: string, label?: string }) => (
    <div className="d-flex align-items-center">
      {!props.compact && <Avatar width={20} avatarUrl={p.tech?.avatarUrl} className="me-2" />}
      <div>
        <div className="fs-7">
          {p.tech?.fullName ?? p.label ?? "Unknown"}
        </div>
        <div className="d-flex align-items-center">
          <Icon icon='phone-office' size={11} className='me-1' />
          <div className="fs-9">{p.number}</div>
        </div>
      </div>
    </div>
  )

  const JobCallerItem = (props: { job?: CompactJob }) => (
    <div className="d-flex align-items-center">
      <Avatar width={20} className="me-2" />
      <div>
        <div className="fs-7">
          {(props.job?.phone?.countryCode ?? "") + props.job?.phone?.phone}
        </div>
        <div className="fs-9">
          {props.job?.fullName}
        </div>
      </div>
    </div>
  )

  const AgentItem = (props: { agent?: CallAgent, ext?: number, number?: string, cid?: string }) => (
    <div className="d-flex align-items-center">
      <Avatar width={20} avatarUrl={props.agent?.avatarUrl} className="me-2" />
      <div>
        <div className="fs-7">
          {props.agent?.name}
        </div>
        <div className="d-flex align-items-center">
          <Icon icon='phone-office' size={11} className='me-1' />
          {
            props.ext && props.ext > 0 ?
              <>
                <div className="fs-8">{props.ext}</div>
                {
                  props.cid ?
                    <div className="fs-9 ms-1" title={props.number}>({props.cid})</div>
                    :
                    <div className="fs-9 ms-1">({props.number})</div>
                }

              </>
              :
              <>
                {
                  props.cid ?
                    <div className="fs-9" title={props.number}>{props.cid}</div>
                    :
                    <div className="fs-9">{props.number}</div>
                }
              </>
          }

        </div>
      </div>
    </div>
  )

  const CallerItem = (props: { country?: any, number?: string, cid?: string }) => (
    <div className="d-flex align-items-center">
      <Avatar width={20} avatarUrl={props?.country?.flagSquare} className="me-2" />
      <div>
        <div className="fs-7">
          {props.number}
        </div>
        <div className="fs-9">
          {props.country?.name}
        </div>
      </div>
    </div>
  )

  const CallSource = (data: Call) => (
    <>
      {
        data.callSource == CallSources.Twilio && data.callType == CallTypes.Outgoing ?
          // Who rang is told by isCallback, not by whether a technician was matched. A callback is
          // the customer ringing the job's proxy number. Anything else is the passcode flow: a
          // technician ringing the customer, very often from a number the system has never been
          // given -- so no technician is matched, and showing the customer there names the person
          // who was called as the one who called. Their number is shown instead.
          data.isCallback ?
            (data.tech ? <TechItem tech={data.tech} number={data.source} /> : <JobCallerItem job={data.job} />)
            : <TechItem tech={data.tech} number={data.source} label="Technician" />
          : data.callSource == CallSources.Twilio && data.callType == CallTypes.Incoming ?
            <JobCallerItem job={data.job} />
            : data.callType == CallTypes.Incoming ?
              <CallerItem country={data.sourceAgent?.country} number={data.sourceAgent?.number} cid={data.sourceCID} />
              :
              <AgentItem agent={data.sourceAgent} ext={data.sourceExtension} number={data.source} cid={data.sourceCID} />
      }
    </>
  )

  const CallDestination = (data: Call) => (
    <>
      {
        data.callSource == CallSources.Twilio && data.callType == CallTypes.Incoming ?
          <TechItem tech={data.tech} number={data.source} />
          : data.callSource == CallSources.Twilio && data.callType == CallTypes.Outgoing ?
            // A callback came from the customer, so they are not who it went to: it rang the job
            // line, which put them through to the technician or the office.
            data.isCallback ?
              <TechItem number={data.destination} label="Job Line" />
              : <JobCallerItem job={data.job} />
            : data.callType == CallTypes.Outgoing && data.destinationAgent?.country ?
              <CallerItem country={data.destinationAgent?.country} number={data.destinationAgent?.number} cid={data.destinationCID} />
              :
              <AgentItem agent={data.destinationAgent} ext={data.destinationExtension} number={data.destination} cid={data.destinationCID} />
      }
    </>
  )

  const CallType = (data: Call) => {
    // A Twilio callback is stored as an outgoing leg, but it is the customer ringing in to the
    // job's proxy number -- incoming as far as anyone reading the list is concerned. Only Twilio:
    // on the PBX isCallback is an agent returning a missed call, which really is outgoing.
    const twilioCallback = data?.callSource == CallSources.Twilio && data?.callType == CallTypes.Outgoing && !!data?.isCallback;
    const incoming = data?.callType == CallTypes.Incoming || twilioCallback;
    const answered = data?.disPosition == "ANSWERED" || data?.twilioCallStatus == "completed";

    return (
      <div>
        {
          incoming &&
          <Icon icon='phone-arrow-down-left' type='solid' className={"text-" + (answered ? "success" : "danger") + " opacity-75"} size={16} title="Incoming Call" />
        }
        {
          data?.callType == CallTypes.Outgoing && !incoming &&
          <Icon icon='phone-arrow-up-right' type='solid' className="text-primary opacity-75" size={16} title="Outgoing Call" />
        }
      </div>
    )
  }

  const CallStatus = (data: any) => (
    <div className="d-flex align-items-center">
      {
        data?.disPosition == "ANSWERED" ?
          <Icon type="solid" icon="phone-volume" className="text-success me-3" />
          : data?.disPosition == "NO ANSWER" ?
            <Icon type="solid" icon="phone-missed" className="text-danger me-3" />
            : data?.disPosition == "BUSY" ?
              <Icon type="solid" icon="phone-xmark" className="text-danger me-3" />
              :
              <Icon type="solid" icon="phone" className="text-gray me-3" />
      }
      <div>
        <div className="callname">
          {data?.disPosition}
        </div>
        {
          data?.callType == CallTypes.Incoming &&
          <div className="callnumber align-items-center d-flex">
            <Icon type="solid" icon="phone-arrow-down-left" className="me-1" size={9} />
            Incoming
          </div>
        }
        {
          data?.callType == CallTypes.Outgoing &&
          <div className="callnumber align-items-center d-flex">
            <Icon type="solid" icon="phone-arrow-up-right" className="me-1" size={9} />
            Outgoing
          </div>
        }
        {
          data?.callType == CallTypes.Local &&
          <div className="callnumber align-items-center d-flex">
            <Icon type="solid" icon="headset" className="me-1" size={9} />
            Local
          </div>
        }
      </div>
    </div>
  )

  const CallJobSource = (data: Call) => {
    // Fallback: if the call record doesn't have JobSource set, derive it from
    // the matched phone line (via lineId). Handles legacy calls written before
    // the backend started populating JobSourceId on the call itself.
    const sourceName = data.jobSource?.name
      ?? (data.lineId ? phoneLines.find(p => p.id === data.lineId)?.jobSourceName : undefined);

    return (
      <div>
        <div className='d-flex align-items-center'>
          {sourceName}
        </div>
        {
          data.queueName &&
          <div className='d-flex align-items-center fs-8 mt-1'>
            <Icon icon="arrow-right-to-line" className="me-1" size={12} />
            <span>
              {data.queueName}
            </span>
          </div>
        }
      </div>
    );
  }

  const CallDurations = (data: Call) => (
    <div>
      <div className='d-flex align-items-center' title='Talk Time'>
        {data.billSecStr}
      </div>
      <div className='d-flex align-items-center fs-8 mt-1' title='Ring Time'>
        <Icon icon="phone-rotary" className="me-1 text-muted" size={12} />
        <span className='text-muted'>
          {data.ringSecStr}
        </span>
      </div>
    </div>
  )

  const CallDate = (data: Call) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.callDate)}
      </div>
      {
        props.compact &&
        <div className='d-flex align-items-center fs-8 mt-1' title='Call Duration'>
          <Icon icon="phone-volume" className="me-1 text-muted" size={12} />
          <span className='text-muted'>
            {data.billSecStr}
          </span>
        </div>
      }
    </div>
  )

  const CallLabels = (data: Call) => {

    return (
      (
        <div className='d-flex align-items-center call-labels'>
          {
            !window.isNullOrEmpty(data.twilioCallStatus) &&
            <span className='badge badge-light-primary'>{data.twilioCallStatus}</span>
          }
          {
            data.disPosition == "ANSWERED" &&
            <span className='badge badge-light-success'>Answered</span>
          }
          {
            data.callType == CallTypes.Incoming && (data.disPosition == "NO ANSWER" || data.disPosition == "BUSY") &&
            <span className='badge badge-light-danger'>Missed Call</span>
          }

          {
            data.callType == CallTypes.Outgoing && (data.disPosition == "NO ANSWER" || data.disPosition == "BUSY") &&
            <span className='badge badge-light-warning'>No Answer</span>
          }

          {
            data.callType == CallTypes.Outgoing && data.isCallback &&
            <span className='badge badge-light-primary'>
              <Icon icon='arrow-rotate-left' size={9} className="me-1" />
              Callback
            </span>
          }

          {
            data.callType == CallTypes.Incoming && data.isCalledback &&
            <Link to={"/voice/call/" + data.calledBackId} className='badge badge-light-success'>
              <Icon icon='arrow-rotate-left' size={9} className="me-1" />
              Called Back
            </Link>
          }

          {
            (data.disPosition == "ANSWERED" || data.twilioCallStatus == "completed") &&
            <>
              {
                data.listeners && data.listeners.length > 0 ?
                  <div>
                    <span className='badge badge-light-primary ms-1 cursor-pointer'
                      data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                      <Icon icon='phone-volume' size={10} className="me-1" />
                      {data.listeners.length} Listeners
                    </span>
                    {
                      <DropdownMenu listerns={data.listeners} width={250} />
                    }
                  </div>
                  :
                  <span className='badge badge-light-danger ms-1'>
                    <Icon icon='phone-slash' size={10} className="me-1" />
                    No Listener
                  </span>
              }
            </>
          }

        </div>
      )
    )
  }

  const CallAgentView = (data: Call) => {

    return (
      <FlexRow>
        {
          jobs?.filter(j => j.phoneRaw == data.sourceAgent?.number)
            .map(job =>
              <a href='#' className='badge badge-light-primary me-1'
                onClick={e => {
                  e.preventDefault()
                  openJobQuickView(job.id)
                }}>
                #{job.jobId}
              </a>
            )
        }

        <a href='#' className='badge badge-secondary'
          onClick={e => {
            e.preventDefault()
            createJob(undefined, data.id)
          }}>
          <Icon icon='plus' className='me-1' />
          New Job
        </a>
      </FlexRow>
    )
  }

  const DetailsAction = (data: any) => (
    <div className="menu-item">
      <Link to={"/voice/call/" + data.id} className="menu-link px-3">
        <Icon icon="clock-rotate-left" className="me-2" />
        Call Details
      </Link>
    </div>
  )

  const ShareAction = (data: any) => (
    <div className="menu-item">
      <a href="#" className="menu-link px-3"
        onClick={e => {
          e.preventDefault();
          shareCalls([data.id]);
        }}
      >
        <Icon icon="share" className="me-2" />
        Share Call
      </a>
    </div>
  )

  const HistoryAction = (data: any) => (
    <div className="menu-item">
      <a href="#" className="menu-link px-3"
        onClick={e => {
          openCallDetails(data);
        }}
      >
        <Icon icon="clock-rotate-left" className="me-2" />
        Quick View
      </a>
    </div>
  )

  const DownloadRecording = (data: Call) => (
    <>
      {
        (data.disPosition == "ANSWERED" || data.twilioCallStatus == "completed") &&
        <div className="menu-item">
          <a href={callRecordingUrl(owner?.id, data.id)} className="menu-link px-3" target="_blank">
            <Icon icon="download" className="me-2" />
            Download
          </a>
        </div>
      }
    </>
  )

  const NotesAction = (data: any) => (
    <div className="menu-item">
      <a href="#" className="menu-link px-3"
        onClick={e => {
          e.preventDefault();
          console.log("notes clicked!")
        }}
      >
        <Icon icon="comment" className="me-2" />
        Notes
      </a>
    </div>
  )

  const openCallDetails = (data: any) => {
    selectedCallSet(data);
    window.openModal("modal-call-quickview");
    if (!modalCloseEvent) {
      window.onModalClose("modal-call-quickview", () => {
        selectedCallSet(null);
      })
      modalCloseEventSet(true);
    }
  }

  const CallDetails = (data: any) => (
    <div className="d-flex align-items-center">
      <Avatar width={20} avatarUrl={(data.sourceAgent?.country ? data.sourceAgent?.country?.flagSquare : data.sourceAgent?.avatarUrl)} className="me-2" />
      <div>
        {
          data?.sourceAgent?.id ?
            <>
              <div className="fs-8">
                {data?.sourceAgent?.name}
                <span className='d-inline-block ms-1 fs-9'>
                  ({data?.sourceAgent?.number})
                </span>
              </div>
            </>
            :
            <>
              <div className="fs-8">
                {data?.sourceAgent?.number}
              </div>
            </>
        }
      </div>
      <div className='badge badge-danger'>
        Busy
      </div>
    </div>
  )

  const PlayRow = (data: Call) => (
    <div className={(props.noAction || props.noMultipleAction) ? "ps-5" : "text-center"}>
      <a href="#"
        title="Play Recording File"
        onClick={e => {
          e.preventDefault();
          if (globalState.selectedCallToPlay?.id == data.id) {
            if (globalState.floatAudioStatus?.playing) pauseGlobalPlayer();
            else playGlobalPlayer();
          }
          else {
            playCall(data);
            $(".data-row").removeClass("selected");
            $("#row-" + data.id).addClass("selected");
          }
        }}>
        {
          hasCallRecording && (data.disPosition == "ANSWERED" || data.callSource == CallSources.Twilio) && !window.isNullOrEmpty(data.recordingFile) ?
            <>
              <Icon icon={(globalState.selectedCallToPlay?.id == data.id && globalState.floatAudioStatus?.playing) ? "pause"
                : (globalState.selectedCallToPlay?.id == data.id && globalState.floatAudioStatus?.loading) ? "spinner"
                  : "play"} type="solid" spin={(globalState.selectedCallToPlay?.id == data.id && globalState.floatAudioStatus?.loading)}
                color="#555" size={17} />
            </>
            :
            <></>
        }

      </a>
    </div>
  )


  useEffect(() => {

  }, [])

  return (
    <>

      <DataTable objectName="Call"
        route="/system/calls"
        filteringProps={FilterProps}
        apiRoute={API_ROUTES.Calls}
        defaultId={props.agentId}
        jobId={props.jobId}
        isChild={props.isChild}
        defaultKeyword={props.keyword}
        noHeader={props.noHeader}
        noFilter={props.noFilter}
        noMultipleActions={props.noMultipleAction}
        noAction={props.noAction}
        refresh={props.refresh}
        extraParams={props.filterParams}
        onDataBinded={data => {
          //window.dataTableMenu()
        }}
        preventCreate share>
        <DataTableField title="" width={30} hidden={props.noPlay}>
          <PlayRow />
        </DataTableField>
        <DataTableField title="" width={30} hidden={props.noType}>
          <CallType />
        </DataTableField>
        <DataTableField title="From">
          <CallSource />
        </DataTableField>
        <DataTableField title="Destination" hidden={props.compact}>
          <CallDestination />
        </DataTableField>
        <DataTableField title='Source' hidden={props.compact}>
          <CallJobSource />
        </DataTableField>
        <DataTableField title="Duration" hidden={props.compact}>
          <CallDurations />
        </DataTableField>
        <DataTableField title="Call Date">
          <CallDate />
        </DataTableField>

        <DataTableField title="Labels" hidden={props.noLabels}>
          <CallLabels />
        </DataTableField>

        <DataTableField title="" hidden={!(props.agentView ?? false)}>
          <CallAgentView />
        </DataTableField>

        <DataTableCustomActions>
          <DetailsAction />
        </DataTableCustomActions>
        {/* <DataTableCustomActions>
          <HistoryAction />
        </DataTableCustomActions> */}
        <DataTableCustomActions>
          <ShareAction />
        </DataTableCustomActions>
        <DataTableCustomActions>
          <DownloadRecording />
        </DataTableCustomActions>
      </DataTable>

      <CallQuickView selectedCall={selectedCall} />

    </>
  );
}

export default CallsList;
